import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';

import { catchError, EMPTY, filter, from, Observable, of, Subscription, switchMap } from 'rxjs';
import { NbDialogService } from '@nebular/theme';

import { EDialogAnswer, TDialogAnswerPayload, TDialogData } from './dialog.types';

export const dialog = () => {
  const dialogService = inject(NbDialogService);
  const destroyRef = inject(DestroyRef);

  function open<T = unknown>(data: Readonly<TDialogData> & { isObservable: true }): Observable<TDialogAnswerPayload<T>>;
  function open<T = unknown>(data: Readonly<TDialogData> & { isObservable?: false }): Subscription;
  function open<T = unknown>(data: Readonly<TDialogData>) {
    const filterBySuccessOnly = (result: TDialogAnswerPayload) => {
      if (data.successOnly) {
        if (!result) {
          return false;
        }

        return result.type === EDialogAnswer.Confirm;
      }

      return true;
    };
    const observable = from(data.component).pipe(
      // Use the map operator to open a dialog with the provided component and options
      switchMap((response) => {
        const dialogRef = dialogService.open(response.default, data.config);

        // Return observable with dialog answer and filter if successOnly flag exist in data
        return dialogRef.onClose.pipe(filter((result) => filterBySuccessOnly(result)));
      }),
      catchError((e) => {
        console.log(`%cAn error occurred while loading component:`, 'color: #ff3a5a; font-weight: bold;', e);

        return EMPTY; // Return an empty Observable in case of an error
      }),
      takeUntilDestroyed(destroyRef),
    );

    if (!data.isObservable) {
      return observable.subscribe();
    }

    return observable;
  }

  return { open };
};
